import * as z from "zod/v4";

export const createMetaAdsAudience = {
  name: "createMetaAdsAudience" as const,
  input: z.object({ accountId: z.string(), name: z.string() }),
  output: z.object({
    audience: z
      .object({
        id: z.string(),
        name: z.string(),
        description: z.string(),
        createdTime: z.number(),
        updatedTime: z.number(),
      })
      .nullable(),
    error: z.string().optional(),
  }),
};
